import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import Users from './components/Users';
import Organizations from './components/Organizations';
import Videos from './components/Videos';
import VideoSessions from './components/VideoSessions';
import VRGlasses from './components/VRGlasses';
import Questionnaires from './components/Questionnaires';
import Assessments from './components/Assessments';
import IbsFormSubmissions from './components/IbsFormSubmissions';
import Downloads from './components/Downloads';

function AppContent() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return <Login />;
  }

  const canSeeSuperAdminMenu = user?.is_super_admin;
  const isOrgAdmin = user?.is_admin;

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          {canSeeSuperAdminMenu && (
            <Route path="/organizations" element={<Organizations />} />
          )}
          {(isOrgAdmin || canSeeSuperAdminMenu) && (
            <Route path="/users" element={<Users />} />
          )}
          <Route path="/videos" element={<Videos />} />
          <Route path="/video-sessions" element={<VideoSessions />} />
          <Route path="/vr-glasses" element={<VRGlasses />} />
          <Route path="/questionnaires" element={<Questionnaires />} />
          <Route path="/assessments" element={<Assessments />} />
          <Route path="/ibs-form-submissions" element={<IbsFormSubmissions />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
